var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: {
      'has-navbar-fixed-top': this.$store.getters.isAdviserSignedIn || ['signup', 'regimento', 'premiacao', 'provas', 'publishedStudents', 'index'].includes(this.$route.name)
    },
    attrs: {
      "id": "app"
    }
  }, [!this.$store.getters.isAdminSignedIn ? _c('AppHeader') : _c('AdminHeader'), _c('main', {
    attrs: {
      "role": "main"
    }
  }, [_c('router-view')], 1), _c('AppFooter')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };